var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3106 19.6759C5.01884 19.6759 3.14844 17.8129 3.14844 15.5137C3.14844 13.2145 5.0114 11.3516 7.3106 11.3516C9.6098 11.3516 11.4728 13.2145 11.4728 15.5137C11.4728 17.8129 9.60236 19.6759 7.3106 19.6759Z",
    fill: "#0C547D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.9999H0.5V25.2251C0.5 22.1617 3.00878 19.6755 6.09993 19.6755H8.89993C11.9911 19.6755 14.4999 22.1617 14.4999 25.2251L14.5 27.9999Z",
    fill: "#0C547D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.803 25.3511V22.5343C21.2523 22.5343 25.6855 18.11 25.6855 12.6716C25.6855 7.23324 21.2523 2.80895 15.803 2.80895C11.3246 2.80895 7.40341 5.8286 6.25902 10.1629L3.52686 9.44924C4.99454 3.88319 10.0374 0 15.7952 0C22.8026 0 28.4998 5.68623 28.4998 12.6791C28.4998 19.672 22.8021 25.3514 15.8021 25.3514L15.803 25.3511Z",
    fill: "#0C547D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3105 13.9999H14.5V5.67554H17.2229V11.2249H21.3108L21.3105 13.9999Z",
    fill: "#0C547D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginTime);
export default __webpack_public_path__ + "static/media/loginTime.fda49eca.svg";
export { ForwardRef as ReactComponent };